<template>
  <transition name="fade">
    <v-card rounded="xl" class="pa-4 mb-4">
      <v-form @submit.prevent="checkForm">
        <v-text-field v-model="nombre" label="Nombre de la agencia" :error-messages="errors.nombre"
          required></v-text-field>

        <v-switch v-if="false" v-model="defaultColor" label="Color por default"></v-switch>
        <v-color-picker v-if="false" v-model="AvaiColor" mode="hexa" hide-canvas
          label="Color etiqueta"></v-color-picker>



        <v-row justify="end">
          <v-btn class="mr-2" @click="$emit('toggle', false)">Cancelar</v-btn>
          <v-btn color="success" type="submit">Guardar</v-btn>
        </v-row>
      </v-form>
    </v-card>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>


<script>
export default {
  name: "editHotelForm",
  components: {},
  props: ["temporadas", "editData"],
  data() {
    return {
      transportacionActivada: false,
      nombre: "",
      AvaiColor: "",
      defaultColor: true,
      id: "",
      errors: {},
    };
  },
  methods: {
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nombre) {
        this.errors.nombre = "El nombre de la agencia es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        this.$emit("successData", this.$data);
      }
    },
  },
  computed: {},
  watch: {},
  beforeMount: function () { },
  mounted() {

    this.id = this.editData.id;
    this.nombre = this.editData.Nombre;
    this.AvaiColor = this.editData.AvaiColor;

    if (this.editData.AvaiColor == 'M') {
      this.defaultColor = true;
    } else {
      this.defaultColor = false;
    }
  },
};
</script>